import React from "react";
import PropTypes from "prop-types";
import Navbar from "react-bootstrap/Navbar";
import logo from "./logo.svg";

const NavBar = (props) => {
  const { icon } = props;
  const skipToMain = () => {
    console.log("SSSKIP");
    props.focusOnMain();
  };
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className="header__topbar"
      role="navigation"
    >
      <Navbar.Brand href="#" className="header__topbar">
        <img
          src={icon}
          alt="metro logo"
          style={{ width: "300px", height: "51px" }}
          aria-label="metro-logo"
        />
      </Navbar.Brand>
      <button className="skip-main" onClick={() => skipToMain()} tabIndex="0">
        Skip to main content
      </button>
      {/* <a className="header__top-menu__item" href={homeLink.url}>
        {homeLink.label}
      </a>
      <NavLink className="header__top-menu__item" to="/user-feedback">
        {feedbackLink.label}
      </NavLink>
      <a className="header__top-menu__item" href={supportLink.url}>
        Help & Support
      </a> */}
    </Navbar>
  );
};
NavBar.propTypes = {
  icon: PropTypes.string.isRequired,
  homeLink: PropTypes.object.isRequired,
  feedbackLink: PropTypes.object.isRequired,
  supportLink: PropTypes.object.isRequired,
};
NavBar.defaultProps = {
  icon: logo,
  homeLink: {
    label: "Metro Home",
    url: "https://www.ridemetro.org/Pages/index.aspx",
  },
  feedbackLink: {
    label: "Feedback",
  },
  supportLink: {
    label: "Help & Support",
    url: "https://www.ridemetro.org/Pages/FareMyQ.aspx",
  },
};
export default NavBar;
